import _objectSpread from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import Logo from "./Logo";
import Menu from "./menu";
import NavbarRight from "../components/NavbarRight";
export default {
  components: {
    Logo: Logo,
    Menu: Menu,
    NavbarRight: NavbarRight
  },
  computed: _objectSpread({}, mapState({
    slideClass: function slideClass(state) {
      return state.settings.slideClass;
    }
  }))
};